var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$slots.default
    ? _c(
        "v-navigation-drawer",
        {
          staticClass: "pa-2",
          attrs: {
            app: "",
            clipped: "",
            color: "secondarybackground",
            right: "",
            value: _vm.value,
            width: 285
          },
          on: {
            input: function($event) {
              return _vm.$emit("input", _vm.value)
            }
          }
        },
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }